import { BaseSensor } from './';
import { TranslationService } from '../services/translation.service';
export class Device{
	protected name:string;
	protected id:number;
	values:Map<string,string>;
	scales:Map<string,BaseSensor>;
	dates:Map<string,Date>;
	translator:TranslationService;
	constructor(id:number){
		this.translator = TranslationService.getInstance();
		this.values = new Map<string,string>();
		this.scales = new Map<string,BaseSensor>();
		this.dates = new Map<string,Date>();

	}
	static translator:TranslationService;

	getId():number{
		return this.id;
	}
	setId(id:number):void{
		this.id = id;
	}
	getName():string{
		return this.name;
	}
	setName(name:string):void{
		this.name = name;
	}


	hasDate(key:string):boolean{
		return this.dates.has(key);
	}
	getDate(key:string):Date{
		return this.dates.get(key);
	}
	setDate(key:string,value:Date):void{
		this.dates.set(key,value);
	}



	hasScale(key:string):boolean{
		return this.scales.has(key);
	}
	setScale(key:string,value: BaseSensor):void{
		this.scales.set(key,value);
	}
	getScale(key:string):BaseSensor{
		return this.scales.get(key);
	}
	setScaleValue(key:string,value:number):void{
		this.scales.get(key).setCurrentValue(value);
	}
	getScaleValue(key:string):number{
		return this.scales.get(key).getCurrentValue();
	}


	hasValue(key:string):boolean{
		return this.values.has(key);
	}
	getValue(key:string):string{
		return this.translator.tr(this.values.get(key));
	}
	getRawValue(key:string):string{
		return this.values.get(key);
	}
	setValue(key:string, value:string):void{
		this.values.set(key,value);
	}
}